"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcLightningAbilityHandler = exports.ArcLightningActorAbilityFactory = exports.ArcLightningAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ArcLightningAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArcLightning;
        this.__typeName = "ArcLightning";
    }
}
exports.ArcLightningAbilityArgs = ArcLightningAbilityArgs;
let ArcLightningActorAbilityFactory = class ArcLightningActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArcLightning", "AllEnemies", 1);
    }
};
ArcLightningActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArcLightning")
], ArcLightningActorAbilityFactory);
exports.ArcLightningActorAbilityFactory = ArcLightningActorAbilityFactory;
let ArcLightningAbilityHandler = class ArcLightningAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const { all: projectilesByTargetId } = targets.reduce(({ last, all }, next) => {
            all.set(next, [{
                    creatorId: last,
                    targetId: next,
                    jitter: 0,
                    path: "line",
                    type: "BlueLightningPulse"
                }]);
            return {
                last: next,
                all
            };
        }, {
            last: targets.at(-1),
            all: new Map()
        });
        container.applyMultiAttack({
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            sequence,
            targets: targets.map(targetId => ({
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
                ],
                jitter: 0,
                targetId: targetId
            })),
            onHit: (sequence, { targetId }, { hit }) => {
                if (hit
                    && container.hasAttribute(ability.invokerId, "Charm_ThunderCaller_1")
                    && container.testAttribute(ability.invokerId, "Luck", 25)) {
                    container.applyProjectiles({
                        sequence,
                        onProjectile: (sequence, { targetId }) => {
                            container.applyAttackDamage({
                                sequence,
                                attackType: "magic",
                                attackerId: ability.invokerId,
                                targetId,
                                toApply: AbilityDamage_1.AbilityDamage.Focus("Nature", 40),
                                isCrit: false
                            });
                        },
                        projectiles: targets.filter(other => other !== targetId)
                            .map(subTargetId => ({
                            creatorId: targetId,
                            targetId: subTargetId,
                            path: "line",
                            jitter: 0,
                            type: "BlueLightningPulse"
                        }))
                    });
                }
            },
            onHitOrMiss: (sequence, { targetId }, { hit, crit }) => {
                container.applyProjectiles({
                    sequence,
                    projectiles: projectilesByTargetId.get(targetId),
                    onProjectile: (sequence, { targetId }) => {
                        if (container.hasAttribute(ability.invokerId, "Charm_ThunderCaller_1")) {
                            container.applyProjectiles({
                                sequence,
                                onProjectile: (sequence, { targetId }) => {
                                    container.applyAttackDamage({
                                        sequence,
                                        attackType: "magic",
                                        attackerId: ability.invokerId,
                                        targetId,
                                        toApply: AbilityDamage_1.AbilityDamage.Focus("Nature", 75),
                                        isCrit: false
                                    });
                                },
                                projectiles: targets.filter(other => other !== targetId)
                                    .map(subTargetId => ({
                                    creatorId: targetId,
                                    targetId: subTargetId,
                                    path: "cos",
                                    jitter: 0,
                                    type: "BlueLightningPulse"
                                }))
                            });
                        }
                    },
                });
            }
        });
    }
};
ArcLightningAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArcLightning)
], ArcLightningAbilityHandler);
exports.ArcLightningAbilityHandler = ArcLightningAbilityHandler;
